module.exports = __webpack_public_path__ + "img/img_icon_29.76021f2a.png";